import { BaseFetch } from "../main-model"
export default class SubjectStructureModel extends BaseFetch {
  getSubjectStructureBy = (data) =>
    this.authFetch({
      url: "subject-structure/getSubjectStructureBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getSubjectStructureById = (data) =>
    this.authFetch({
      url: "subject-structure/getSubjectStructureById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSubjectStructureById = (data) =>
    this.authFetch({
      url: "subject-structure/updateSubjectStructureById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSubjectStructure = (data) =>
    this.authFetch({
      url: "subject-structure/insertSubjectStructure",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSubjectStructureById = (data) =>
    this.authFetch({
      url: "subject-structure/deleteSubjectStructureById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
